// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hr","advertCardNum":"c-a_hs"};